import { type QueryNodes } from '../models';
import { toNodes } from './toNodes';

export function getNodes<Response>(data?: Response): QueryNodes<Response> {
    const key = data ? (Object.keys(data)[0] as keyof Response) : null;
    const conn = key ? data?.[key] : null;

    return toNodes(conn);
}
